<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="title">
        {{ selectedChangelog ? 'Sửa phiên bản' : 'Thêm phiên bản' }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          ref="version"
          v-model="version"
          label="Phiên bản"
          :disabled="!!selectedChangelog"
        ></v-text-field>
        <v-text-field
          ref="title"
          v-model="title"
          label="Tiêu đề"
        ></v-text-field>
        <v-menu
          ref="dateMenu"
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              label="Ngày"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateMenu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dateMenu.save(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <!-- ! Tính năng -->
        <div>
          <div class="font-weight-bold">Tính năng <v-btn icon @click="addMore('features')" small color="orange">
            <v-icon color="white">add</v-icon>
          </v-btn>
          </div>
          <div
            v-for="(feature, index) in features['vi-VN']"
            :key="index"
            class="d-flex align-center mb-2"
          >
            <span class="mr-2">{{ index + 1 }}.</span>
            <v-text-field
              v-model="features['vi-VN'][index]"
              label="Tiếng Việt"
              class="mr-2"
              style="width: 45%;"
            />
            <v-text-field
              v-model="features['en-US'][index]"
              label="Tiếng Anh"
              class="mr-2"
              style="width: 45%;"
            />
            <v-spacer></v-spacer>
             <v-btn icon flat color="teal" @click="moveUp('features', index)">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn icon flat color="cyan" @click="moveDown('features', index)">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <v-btn icon flat color="error" @click="remove('features', index)">
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- ! Cải thiện -->
        <div>
          <div class="font-weight-bold">Cải thiện <v-btn icon @click="addMore('improvements')" small color="blue">
            <v-icon color="white">add</v-icon>
          </v-btn>
          </div>
          <div
            v-for="(improvement, index) in improvements['vi-VN']"
            :key="index"
            class="d-flex align-center mb-2"
          >
            <span class="mr-2">{{ index + 1 }}.</span>
            <v-text-field
              v-model="improvements['vi-VN'][index]"
              label="Tiếng Việt"
              class="mr-2"
              style="width: 45%;"
            />
            <v-text-field
              v-model="improvements['en-US'][index]"
              label="Tiếng Anh"
              class="mr-2"
              style="width: 45%;"
            />
            <v-spacer></v-spacer>
            <v-btn icon flat color="teal" @click="moveUp('improvements', index)">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn icon flat color="cyan" @click="moveDown('improvements', index)">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <v-btn icon flat color="error" @click="remove('improvements', index)">
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- ! Sửa lỗi -->
        <div>
          <div class="font-weight-bold">Sửa lỗi <v-btn icon @click="addMore('fixes')" small color="green">
            <v-icon color="white">add</v-icon>
          </v-btn>
          </div>
          <div
            v-for="(fix, index) in fixes['vi-VN']"
            :key="index"
            class="d-flex align-center mb-2"
          >
            <span class="mr-2">{{ index + 1 }}.</span>
            <v-text-field
              v-model="fixes['vi-VN'][index]"
              label="Tiếng Việt"
              class="mr-2"
              style="width: 45%;"
            />
            <v-text-field
              v-model="fixes['en-US'][index]"
              label="Tiếng Anh"
              class="mr-2"
              style="width: 45%;"
            />
            <v-spacer></v-spacer>
            <v-btn icon flat color="teal" @click="moveUp('fixes', index)">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn icon flat color="cyan" @click="moveDown('fixes', index)">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <v-btn icon flat color="error" @click="remove('fixes', index)">
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" flat @click="close">Hủy</v-btn>
        <v-btn color="primary" @click="onSubmit">{{ selectedChangelog ? 'Sửa' : 'Thêm' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: { },

  data: () => ({
    // dialog
    dialog: false,
    selectedChangelog: null,
    existedVersion: [],

    // form
    version: '',
    title: '',
    date: new Date().toISOString().split('T')[0],
    dateMenu: false,
    features: { 'vi-VN': [], 'en-US': [] },
    improvements: { 'vi-VN': [], 'en-US': [] },
    fixes: { 'vi-VN': [], 'en-US': [] },


  }),

  watch: {
    version (newVersion) {
      if (!this.selectedChangelog) {
        this.title = `v${newVersion}`;
      }
    }
  },

  methods: {
    ...mapActions(['']),

    open (selectedChangelog, changelogList) {
      this.dialog = true;

      if (selectedChangelog) {
        this.selectedChangelog = selectedChangelog;
        this.version = selectedChangelog.version;
        this.title = selectedChangelog.title;
        this.date = selectedChangelog.date;
        // eslint-disable-next-line no-undef
        this.features = selectedChangelog.features ? structuredClone(selectedChangelog.features) : { 'vi-VN': [], 'en-US': [] };
        // eslint-disable-next-line no-undef
        this.improvements = selectedChangelog.improvements ? structuredClone(selectedChangelog.improvements) : { 'vi-VN': [], 'en-US': [] };
        // eslint-disable-next-line no-undef
        this.fixes = selectedChangelog.fixes ? structuredClone(selectedChangelog.fixes) : { 'vi-VN': [], 'en-US': [] };
      }

      if (changelogList) {
        this.existedVersion = changelogList.map(changelog => changelog.version);
      }
    },

    onSubmit () {
      if (!this.version || !this.title || !this.date) {
        window.getApp.showMessage('Vui lòng điền đầy đủ thông tin', 'error');
        return;
      }

      if (this.existedVersion.includes(this.version) && !this.selectedChangelog) {
        window.getApp.showMessage('Phiên bản đã tồn tại', 'error');
        return;
      }

      const result = {
        version: this.version,
        title: this.title,
        date: this.date,
        features: this.features,
        improvements: this.improvements,
        fixes: this.fixes,
      };

      if (this.hasEmptyLanguage(result)) {
        window.getApp.showMessage('Không được để trống ngôn ngữ', 'error');
        return;
      }

      if (this.selectedChangelog) {
        this.$emit('update', result);
      } else {
        this.$emit('add', result);
      }
      this.close();
    },

    addMore (type) {
      this[type]['vi-VN'].push('');
      this[type]['en-US'].push('');
    },

    remove (type, index) {
      this[type]['vi-VN'].splice(index, 1);
      this[type]['en-US'].splice(index, 1);
    },

    moveUp (type, index) {
      if (index <= 0) return;

      const tempVi = this[type]['vi-VN'][index];
      this[type]['vi-VN'].splice(index, 1);
      this[type]['vi-VN'].splice(index - 1, 0, tempVi);

      const tempEn = this[type]['en-US'][index];
      this[type]['en-US'].splice(index, 1);
      this[type]['en-US'].splice(index - 1, 0, tempEn);
    },

    moveDown (type, index) {
      if (index >= this[type]['vi-VN'].length - 1) return;

      const tempVi = this[type]['vi-VN'][index];
      this[type]['vi-VN'].splice(index, 1);
      this[type]['vi-VN'].splice(index + 1, 0, tempVi);

      const tempEn = this[type]['en-US'][index];
      this[type]['en-US'].splice(index, 1);
      this[type]['en-US'].splice(index + 1, 0, tempEn);
    },

    close () {
      this.dialog = false;
      this.reset();
    },

    reset () {
      this.version = '';
      this.title = '';
      this.date = new Date().toISOString().split('T')[0];
      this.features = { 'vi-VN': [], 'en-US': [] };
      this.improvements = { 'vi-VN': [], 'en-US': [] };
      this.fixes = { 'vi-VN': [], 'en-US': [] };
      this.selectedChangelog = null;
      this.existedVersion = [];
    },

    hasEmptyLanguage (data) {
      for (const key of ['features', 'improvements', 'fixes']) {
        for (const locale in data[key]) {
          if (data[key][locale].some(item => item === '')) {
            return true;
          }
        }
      }
      return false;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/changelog/DialogCreateUpdateChangelog.vue